export const getCalculateAmountAndVat = (total, total_vat)=>{
    let values = `${Number(total) + Number(total_vat)}`
    let amount_vat = parseFloat(values.replace(',', '.'))
    return Number(amount_vat).toFixed(2)
}
export const getCalculateVat = (total, vat)=>{
    let values = `${total / 100 * Number(vat)}`
    let amount_vat = parseFloat(values.replace(',', '.'))
    return Number(amount_vat).toFixed(2)
}